import React from "react";
import LegalPageLayout from "./LegalPageLayout";
import C from "./legal.config";

export default function CommunityGuidelines() {
  return (
    <LegalPageLayout title="Community Guidelines" version={C.versions.community}>
      <p>
        LEAGUE HUB is for competitive players who want fair, drama-free
        matches. These guidelines explain what conduct is welcome here,
        what isn't, and how we enforce them. They sit alongside the{" "}
        <a href="/legal/terms" className="underline">Terms of Service</a>.
      </p>

      <h2 className="legal-h2">1. What's welcome</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>Trash talk between consenting opponents, kept in your own DMs or scrim threads.</li>
        <li>Coaching, advice, and constructive feedback to teammates.</li>
        <li>Sharing clips and highlight reels of your own play.</li>
        <li>League managers running their ladder however they want, within the rules below.</li>
      </ul>

      <h2 className="legal-h2">2. Not welcome</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Harassment</strong> — targeted insults, sexual harassment, threats, doxxing, brigading.</li>
        <li><strong>Hate speech</strong> — slurs or attacks based on race, ethnicity, national origin, religion, disability, sexual orientation, gender identity, or any other protected characteristic.</li>
        <li><strong>Cheating</strong> — wallhacks, aimbots, scripts, exploiting bugs for ranked advantage, scoresheet tampering.</li>
        <li><strong>Smurfing / boosting</strong> — playing on alt accounts to dodge MMR, or paying someone to play your ranked.</li>
        <li><strong>Impersonation</strong> — pretending to be another LEAGUE HUB player, a known pro player, a moderator, or a game publisher.</li>
        <li><strong>Illegal content</strong> — including child sexual abuse material, threats of violence, and incitement to commit a crime.</li>
        <li><strong>Spam</strong> — mass DMs, friend-request floods, league-shill posts, link farming.</li>
      </ul>

      <h2 className="legal-h2">3. How to report</h2>
      <p>
        Every player card has a <strong>REPORT PLAYER</strong> button.
        Click it, pick the reason, add a sentence or two of context, and
        the report goes to the league's moderation queue plus our central
        moderation team. You'll see a confirmation. We aim to triage
        reports within <strong>72 hours</strong>, faster for safety
        issues.
      </p>
      <p>
        For urgent issues (CSAM, credible threats), email{" "}
        <a href={`mailto:${C.abuse_email}`}>{C.abuse_email}</a> directly.
      </p>

      <h2 className="legal-h2">4. Enforcement</h2>
      <p>
        Depending on severity we may issue:
      </p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>A warning</strong> — first-time minor breach.</li>
        <li><strong>A timeout</strong> — temporary lock of DMs, league membership, or matchmaking.</li>
        <li><strong>A suspension</strong> — full account lock pending review (1–30 days).</li>
        <li><strong>A permanent ban</strong> — for cheating, hate speech, illegal content, or repeat offences.</li>
      </ul>
      <p>
        League managers may also ban a player from their own ladder
        without affecting platform-wide standing.
      </p>

      <h2 className="legal-h2">5. Appeals</h2>
      <p>
        If you believe enforcement was incorrect, reply to the
        notification email or write to{" "}
        <a href={`mailto:${C.contact_email}`}>{C.contact_email}</a>. A
        moderator who was not involved in the original decision will
        review.
      </p>
    </LegalPageLayout>
  );
}
